import { ActiveModelSerializer } from 'active-model-adapter';
import { ModelRegistry } from 'ember-data/model';
import { isEmpty } from '@ember/utils';

export default class ApplicationSerializer extends ActiveModelSerializer {
  modelNameFromPayloadKey(payloadKey: string) {
    let modelName = super.modelNameFromPayloadKey(payloadKey);
    if (modelName === 'most-recent-trigger' || modelName === 'trigger') {
      return 'broadcast-trigger';
    }

    if (payloadKey === 'note' || payloadKey === 'notes') {
      return 'campaign-note';
    }

    return modelName;
  }

  payloadKeyFromModelName(modelName: keyof ModelRegistry) {
    if (modelName === 'campaign-note') {
      return 'note';
    }

    return super.payloadKeyFromModelName(modelName);
  }

  extractErrors(store: any, model: any, err: any, id: any) {
    let orig = super.extractErrors(store, model, err, id);

    // Since ED 4.8 this is called to re-set "errors" on an InvalidError from the
    // response, even if it already has them set during construction: "new InvalidError(errors)"
    //
    // It seems we have to override it to ensure our custom errors aren't removed -
    // basically preserving previous behaviour (pre-ED 4.8).
    //
    // Relevant tests:
    // - http://127.0.0.1:4200/tests?testId=96905ad4
    let empty = isEmpty(orig) || (typeof orig === 'object' && isEmpty(Object.keys(orig)));
    let res = !empty ? orig : err?.errors;

    return res;
  }
}
